<script>
import { mapState } from 'vuex'
import VVersionInfo from '@/components/VVersionInfo'
import VFadeTransition from '@/components/VFadeTransition'
import env from '@/env'
import api from '@/api'

export default {
  name: 'App',
  components: {
    VVersionInfo,
    VFadeTransition,
  },
  computed: {
    ...mapState({
      version: 'version',
      clientName: 'clientName',
    }),
  },
  watch: {
    clientName(clientName) {
      if (clientName) {
        document.title = clientName
      }
    },
  },
  beforeCreate() {
    api
      .isAuthenticated()
      .then(() => window.location.assign(env.redirectPath()))
      .catch(error => this.$log.info(error))
  },
}
</script>

<template>
  <div class="app">
    <VFadeTransition>
      <router-view/>
    </VFadeTransition>

    <VVersionInfo
      :system="version.system"
      class="login__version-info"
    />
  </div>
</template>

<style>
.app {
  height: 100%;
  min-height: 100vh;
  background-image: url('https://agilepromoter-public-images.s3.amazonaws.com/stage-login-background.jpg');
  background-size: cover;
  background-color: #242046;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

@media (min-height: 768px) {
  .app {
    padding: 0;
  }
}

@media (min-width: 400px) {
  .app {
    padding: var(--space-16);
  }
}
</style>
